module.exports = __webpack_public_path__ + "fonts/Manrope-700-cyrillic-ext19.64f66ba.woff2";